module.exports = __webpack_public_path__ + "static/media/lc-100.7de64784.svg";